import {React} from 'react';
export function handleSubmit(event) {
    event.preventDefault();
    Registrar();
}

export function Register(){

    return(
    <div style={{ textAlign: 'center', padding: '40px 20px', maxWidth: '600px', margin: '0 auto' }}>

        
        <form onSubmit={handleSubmit}>
            <h2>Registration Form</h2>
            <fieldset>
                <table align='center'>
                    <tr>
                        <td>
                            <label>Please tell us your name:</label>
                        </td>
                        <td>
                            <input type='text' id='txtUserName'></input>
                        </td>
                    </tr>                    
                    <tr>
                        <td>
                            <label>e-mail address:</label>
                        </td>
                        <td>
                            <input type='text' id='txtEmail'></input>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>Password:</label>
                        </td>
                        <td>
                            <input type='password' id='txtPassWord'></input>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>Confirm password:</label>
                        </td>
                        <td>
                            <input type='password' id='txtPassWordConfirmation'></input>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan='2'>
                            <button type="submit">Register</button>
                        </td>
                    </tr>
                </table>
            </fieldset>
        </form>
    </div>
        
    );
}


export function Registrar() {
    
    // Function to handle registration logic
    // This function can be expanded to include form validation, API calls, etc.
    let userName = document.getElementById('txtUserName').value;
    let email = document.getElementById('txtEmail').value;
    let password = document.getElementById('txtPassWord').value;
    let passwordConfirmation = document.getElementById('txtPassWordConfirmation').value;
    console.log("username: " + userName);
    console.log("password: " + password);
    console.log("password confirmation: " + passwordConfirmation);
    console.log("email: " + email);

    if (userName === '' || password === '' || passwordConfirmation === '') {
        alert('Para registrarse, por favor rellene todos los campos del formulario de registro!');
        return;
    }
    else{
        if (password !== passwordConfirmation) {
            alert('Las contraseñas no coinciden. Por favor, inténtelo de nuevo, asegurándose que ambas contraseña y confirmación coincidan!');
            return;
        }
        else{
            // Here you can add logic to save the user data, e.g., sending it to a server
            // For now, we will just alert the user that they have been registered
            console.log(`Usuario ${userName} va a intentar ser registrado!`);

            const fetchData = async () => {
                
                try {

                    //const $url = "http://localhost:5000";
                    const $url = "https://api.mtb.cr";
                    console.log('Attempting to register user:', userName);
                    console.log('Sending request to:', $url+'/register');
                    
                    // Test if backend is reachable
                    /*
                    try {
                        const pingResponse = await fetch($url, { method: 'HEAD', mode: 'no-cors' });
                        console.log('Backend is reachable');
                    } catch (pingErr) {
                        console.error('Backend not reachable:', pingErr);
                    }
                    */
                    const response = await fetch($url+'/register', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ userName, password, email }), // Send user data as JSON
                    }); // Replace with your API endpoint
                    console.log('Response status:', response.status);
                    if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const result = await response.json();
                    console.log('Registration successful:', result);
                    alert(result.message || 'User registered successfully!');
                    
                } catch (err) {
                    console.error("Registration error:", err);
                    console.error("Error name:", err.name);
                    console.error("Error message:", err.message);
                    alert('Error during registration: ' + err.message);
                } finally {
                    console.log("Registration process completed");
                }

            }
            fetchData();
        }
        
    }

}
